import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MessageSentWithComponent } from './components/message-sent-with/message-sent-with.component'
import { MatTooltipModule } from '@angular/material/tooltip'
import { IntegrationLibModule } from '@tokeet-frontend/integrations'

const components = [MessageSentWithComponent]
const dialogs = []

const services = []

const modules = [MatTooltipModule, IntegrationLibModule]

@NgModule({
  imports: [CommonModule, ...modules],
  providers: [...services],
  declarations: [...dialogs, ...components],
  entryComponents: [...dialogs],
  exports: [...modules, ...components],
})
export class InquiryLibModule {}
